import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row w-full" }
const _hoisted_2 = {
  key: 0,
  class: "colCenter marg-s"
}
const _hoisted_3 = {
  key: 2,
  class: "pad-s"
}
const _hoisted_4 = {
  key: 3,
  class: "pad-s"
}

import { ref, computed, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import addThirdPersonForm from "@/components/form/addThirdPersonForm.vue";
import loadingSpinner from '@/views/loadingSpinner.vue';
import { useAppUserStore } from '@/stores/appUser'
import { ThirdPersonApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import officeapi from '@/api/officeapi';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esHealthProSearch',
  emits: ['afterAddingPwr'],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const thirdPersonApi = new ThirdPersonApi(medServerApiConfig);
const currentEntryStore = useCurrentEntryStore();
const appUserStore = useAppUserStore()
const toast = useToast();
const { t } = useI18n();
const dropd = ref("");
const searchInputRef = ref();
const searchInput = ref("");
const loadingHealthPros = ref(false);

const currInstituteUuid = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {
    return "";
  }
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole;
  return currentIwr.instituteWithRoleId;
});

const existingCustomHealthPros = ref([]);
async function getExistingCustomHealthPros() {
  if (!currInstituteUuid.value) return;
  loadingHealthPros.value = true;
  try {
    const result = await thirdPersonApi.findThirdPersonHealthProByInstitute({instituteId: currInstituteUuid.value});
    const mappedResult = result.map(person => ({
      text: PersonService.formatName(person.lastname, person.firstname),
      value: person.id
      }))
      .sort((a, b) => a.text.localeCompare(b.text, 'fr'));
    existingCustomHealthPros.value = mappedResult;
  } catch (error: any) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  } finally {
    loadingHealthPros.value = false;
  }
}

const filteredHealthPros = computed(() => {
  const search = searchInput.value.toLowerCase().trim();
  let results = existingCustomHealthPros.value;
  if (search) {
    results = results.filter(hp => 
      hp.text.toLowerCase().includes(search)
    );
  }
  return results.slice(0, 20);
});

function afterPersonCreated() {
  dropd.value = "";
  getExistingCustomHealthPros();
  innerFocus();
}

async function addPwrPersonToPwrPatient(pwrThirdPerson: any) {
  const pwrThirdPersonId = pwrThirdPerson.value;
  const pwrPatientId = currentEntryStore.modalPatient.personWithRoleId;
  dropd.value = '';
  try {
    await officeapi.addPwrPersonToPwrPatient(pwrPatientId, pwrThirdPersonId);
  } catch (error: any) {
    await toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  }
  emits("afterAddingPwr");
}

function innerFocus() {
  nextTick(() => {
    if (!searchInputRef.value) return;
    searchInputRef.value.innerRef.focus()
  })
}

onMounted(() => {
  getExistingCustomHealthPros();
  innerFocus();
})


return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal w-maxC",
    style: {"height":"20rem"},
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
        openOn: "HealthProPlus",
        class: "mleft-auto"
      }, {
        dropd: _withCtx(() => [
          _createVNode(addThirdPersonForm, {
            onAfterPersonCreated: _cache[0] || (_cache[0] = ($event: any) => (afterPersonCreated()))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_es_button, {
            label: _unref(t)('action.createNew'),
            "is-primary": false
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_text_item, {
      txt: _unref(t)('healthPro.select'),
      styles: "font-mBold",
      class: "mleft-02 mtop-12"
    }, null, 8, ["txt"]),
    _createVNode(_component_inputComboBox2, {
      ref_key: "searchInputRef",
      ref: searchInputRef,
      modelValue: searchInput.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchInput).value = $event)),
      styles: "pad-m",
      style: {"width":"20rem"},
      placeholder: _unref(t)('action.search') + ' ...',
      class: "mtop-02"
    }, {
      dropd: _withCtx(() => [
        _createVNode(_component_dbGroup, { class: "mtop-06" }, {
          default: _withCtx(() => [
            (loadingHealthPros.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(loadingSpinner, {
                    logo: false,
                    style: 'w-3'
                  })
                ]))
              : (filteredHealthPros.value.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredHealthPros.value, (healthPro, index) => {
                    return (_openBlock(), _createBlock(_component_list_group, {
                      key: index,
                      styles: "pad-s",
                      onClick: ($event: any) => (addPwrPersonToPwrPatient(healthPro))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: healthPro.text,
                          class: "mleft-08"
                        }, null, 8, ["txt"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                : (searchInput.value.trim())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('healthPro.search.noResult'),
                        styles: "main-l",
                        class: "mleft-04"
                      }, null, 8, ["txt"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('healthPro.search.placeholder'),
                        styles: "main-l",
                        class: "mleft-04"
                      }, null, 8, ["txt"])
                    ])),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mtop-06" }, null, -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mtop-50" }, null, -1))
  ]))
}
}

})